import $ from 'jquery';
import { trackPsykheAddToCart } from "../../modules/psykhe";

function addToBag(code, size, event){
    if(!size || !code) return;
    var pdpData = window.rcProps.pdp || {};
    var sectionURL = pdpData.sectionURL;
    var sessionID = pdpData.sessionId;
    var retailPrice = pdpData.retailPrice;

    window.addProduct(code, size, sectionURL, sessionID, 1, function(atbResponseObj) {
        var data = $.param({
            code : code,
            size : size
        });

        $.modal({
            url: "/fw/ajax/AddToBagPopup.jsp",
            data: data,
            type: 'small',

            triggerOpen: true,
            returnFocus: event ? $(event.currentTarget) : "",
            onComplete : function(){
                updateBagCount();
                trackPsykheAddToCart(code, atbResponseObj);

                if (typeof gaAddToCartActionWithAjax === 'function'){
                    gaAddToCartActionWithAjax('add',code,size,1);
                }

                if (typeof insertGoogleRemarketingAddToCart === 'function') {
                    insertGoogleRemarketingAddToCart();
                }

                if (typeof insertFacebookAddToCart === 'function') {
                    insertFacebookAddToCart(code, retailPrice);
                }
                if (typeof addToCartYahoo === 'function'){
                    addToCartYahoo(code);
                }
                if (typeof insertCriteoAddToCart === 'function') {
                    insertCriteoAddToCart(code);
                }
                if (typeof iPinYouAddtoCart === 'function'){
                    iPinYouAddtoCart(code);
                }
                if (typeof insertKakaoAddToCart === 'function') {
                    insertKakaoAddToCart(code);
                }
                if (typeof insertRTBHouseAddToCart === 'function'){
                    insertRTBHouseAddToCart(code);
                }
                if(typeof insertTiktokAddToCart === "function"){
                    insertTiktokAddToCart(code);
                }

                if (typeof brazeAddToCart === 'function') {
                    brazeAddToCart('add',
                        code,
                        pdpData.productName,
                        size,
                        pdpData.imageUrl,
                        pdpData.pdpUrl,
                        pdpData.retailPrice,
                        pdpData.currency,
                        pdpData.department,
                        pdpData.color,
                        pdpData.brandName,
                        pdpData.categoryName,
                        pdpData.cat1);
                }
            }
        });
    });
}

function updateBagCount(){
    $.ajax(
        {url:"/fw/ajax/CartItemCount.jsp",cache:false}
    ).done(function(msg){
        if(msg.bagCount){
            $("#cart_item_count").text(msg.bagCount);
        }
        else{
            console.error("cart item message cannot be parsed");
        }
    });
}

export default addToBag;



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag.js